import { cache } from "react"
import { i18nConfig } from "@/i18Config"
import type { IContentItem } from "@kontent-ai/delivery-sdk"

import { SimulateurChange } from "@/types/kontent-generated"
import { getDeliveryClient } from "@/lib/kontent/client"

import { assertItemResponse, fetchKontent } from "../helpers"

export type TResolvedSimulateurChange = {
  isReverse: boolean
}

/**
 * Maps an already-fetched SDK item, avoiding a redundant Delivery API call
 * when the item was already resolved by a parent query's depth parameter.
 */
export async function GetSimulateurChangeFromItem(
  rawItem: IContentItem
): Promise<TResolvedSimulateurChange> {
  const simulateur = rawItem as SimulateurChange
  return {
    isReverse:
      simulateur.elements.change_de_base.value[0]?.codename !== "eur_chf",
  }
}

async function _fetchSimulateurChange(
  codename: string,
  previewMode = false
): Promise<TResolvedSimulateurChange> {
  return fetchKontent("Simulateur Change", async () => {
    const client = getDeliveryClient(previewMode)
    const response = await client
      .item<SimulateurChange>(codename)
      .languageParameter(i18nConfig.defaultLocale)
      .toPromise()

    const simulateur = assertItemResponse(response, "Simulateur Change")
    return GetSimulateurChangeFromItem(simulateur)
  })
}

export const GetSimulateurChange = cache(_fetchSimulateurChange)
